import { FLEXBENEFITS_IDCARD_EXPERIMENT_KEY } from "core/constants/experiments";
import {
  useFeatureFlag,
  UseFeatureFlagResult,
} from "core/hooks/useFeatureFlag";

export type UseFlexBenefitsIdCardFeatureFlagResult = UseFeatureFlagResult;

/**
 * Returns the Slice 4 FlexBenefits ID card/wallet placeholder flag state.
 * Separate from useFlexBenefitsFeatureFlag (Slice 1) so this placeholder can ship
 * and roll back independently. Mirrors useWalletFeatureFlag/useFlexBenefitsFeatureFlag.
 */
export function useFlexBenefitsIdCardFeatureFlag(): UseFlexBenefitsIdCardFeatureFlagResult {
  return useFeatureFlag(FLEXBENEFITS_IDCARD_EXPERIMENT_KEY);
}
